import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type Teacher from 'district-ui-client/models/teacher'
import type { SubscriptionStatus } from 'district-ui-client/models/school-subscription'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type DateTransform from 'district-ui-client/transforms/date'
import type StringTransform from 'district-ui-client/transforms/string'

export default class TeacherSubscription extends Model {
  // date transform expects ISO8601 format, backend provides as yyyy-MM-dd format which is technically still ISO8601
  @attr<DateTransform>('date') declare startDate: Date

  @attr<DateTransform>('date') declare endDate: Date

  @attr<StringTransform>('string') declare status: SubscriptionStatus

  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @belongsTo<Teacher>('teacher', { async: false, inverse: 'teacherSubscriptions' }) declare teacher?: Teacher

  get isActive() {
    return this.status === 'active'
  }

  [Type] = 'teacher-subscription' as const
}
